export default "__VITE_ASSET__BxsssP0w__"